import styled from "styled-components";

export const ButtonContainer = styled.button`
  background-color: #101e8e;
  border: 0px;
  text-transform: uppercase;
  min-width: 64px;
  padding: 10px 45px;
  color: #ffffff;
  text-size: 16px;
  font-family: "Segoe UI";
  font-style: normal;
  font-weight: 700;
  display: flex;
  align-items: center;
  &:hover {
    opacity: 0.8;
  }
`;
